// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.


// RUN USING THIS COMMAND...
// node --max_old_space_size=60048 ./node_modules/@angular/cli/bin/ng serve --configuration=tsa_local    

// The Full Application is dependant upon three other services/applications!

export const environment = {
  production: false,
  legalTimezone: 'Australia/Brisbane',
  legalUtcOffsetMinutes: 600,

  
  title: 'TSA 2.0 - txc',
  build: 'SG_6',

  appURL: 'https://localhost:44362', // root directory
  system_URL: 'https://localhost:44362', // global system holding host URL for browser access.
      // appURL: 'https://tsa.backvault.com.au', // root directory
      // system_URL: 'https://tsa.backvault.com.au', // global system holding host URL for browser access.
  
  // appURL: 'https://txctsa.azurewebsites.net', // root directory
  // system_URL: 'https://txctsa.azurewebsites.net', // global system holding host URL for browser access.

  // TODO: change this for local builds.
  // New Azure Variables - LOCAL IIS
  azure_webRootPath: 'https://localhost:44362/', // global system holding host URL for browser access.
  WordTemplates_webRootPath: 'https://localhost:44362/WordTemplates',
  created_documents_webRootPath: 'https://localhost:44362/documents_created',
     TsxTSA_Websocket: 'wss://localhost:44362/api/TXWebSocket',


  // azure_webRootPath: 'https://txctsa.azurewebsites.net/', // global system holding host URL for browser access.
  // WordTemplates_webRootPath: 'https://txctsa.azurewebsites.net/WordTemplates',
  // created_documents_webRootPath: 'https://txctsa.azurewebsites.net/documents_created',
  // //  TsxTSA_Websocket: 'wss://localhost:44362/',
  //  TsxTSA_Websocket: 'wss://backend.textcontrol.com?access-token=Wexrf2EDhT9MxNwTgzaN',

  
//TODO: change this for live builds
    // New Azure Variables LIVE
    // azure_webRootPath: 'https://txctsa.azurewebsites.net/', // global system holding host URL for browser access.
    // WordTemplates_webRootPath: 'https://txctsa.azurewebsites.net/WordTemplates',
    // created_documents_webRootPath: 'https://txctsa.azurewebsites.net/documents_created',


  // Main Slimm Application and Api Database access
  apiURL: 'https://tsa-api.backvault.com.au/slimapp/public', // root directory
  clientApiURL: 'http://localhost:8088', // local Sharmans Client API gateway
  clientApiLocalURL: 'http://localhost:8088',
  clientApiBackvaultURL: 'https://client-api.backvault.com.au',
  clientApiProductionURL: 'https://client-api.sharmangroup.au',
  clientApiLocalPortalURLTemplate: 'https://localhost:44362/#/client/profile/{brand_id}',
  clientApiBackvaultPortalURLTemplate: 'https://tsa.backvault.com.au/#/client/profile/{brand_id}',
  clientApiProductionPortalURLTemplate: 'https://sharmans.online/#/client/profile/{brand_id}',
  clientApiLocalSampleAppURL: 'http://127.0.0.1:8090',
  clientApiBackvaultSampleAppURL: 'https://backvault-my-investigations-corp.sharmangroup.au',
  clientApiProductionSampleAppURL: 'https://my-investigations-corp.sharmangroup.au',
  clientApiSampleSourceURL: 'https://backvault-my-investigations-corp.sharmangroup.au/downloads/my-investigations-node-starter.zip',
  php_apiURL: 'http://tsa.backvault.com.au/APP_PHP', // base directory PHP API and scrupts run from
  php_apiURL_SSL: 'https://tsa.backvault.com.au/APP_PHP', // base directory PHP API and scrupts run from

  // apiURL: 'https://rest.nickbowen.com.au', // root directory -- old calls in system now converted over

  // Current - Internal App API +  Database + Authentication Server - SLIM AND MYOB - ALSO NEEDS TO BE UPDATED IN NODE APP for myob api.
  $api_get_url: 'https://tsa-api.backvault.com.au/slimapp/public',


 // sopNode - MYOB
  // sopNodeURL: 'https://myobapi.sharmans.net.au', // root directory -- live
  // $api_get_sopNode: 'https://myobapi.sharmans.net.au', // -- live

 // sopNode - MYOB
//  sopNodeURL: 'http://localhost:1050', // root directory // - local running local host tsa.backvault. /localhost nodejs port.
//  $api_get_sopNode: 'http://localhost:1050',

// New scope 2026 - must be ssl
  sopNodeURL: 'https://sopnode.nickbowen.com.au', // root directory // - local running local host tsa.backvault. /localhost nodejs port.
 $api_get_sopNode: 'https://sopnode.nickbowen.com.au',
 

//  PDF encryption Services - External Node JS app.
//  adobeAPIURL: 'http://localhost:1055', // root directory // - local running local host tsa.backvault. /localhost nodejs port.
 adobeAPIURL: 'https://adobeapi.backvault.com.au', // root directory // - local running local host tsa.backvault. /localhost nodejs port.


 // googleAuthURL: 'http://localhost:3022', // new may 24 TFA noode.js authentication app services.
// googleAuthURL: 'https://googleauthtsa.backvault.com.au', // new may 24 TFA noode.js authentication app services. --- googleAuthTSA.backvault.com.au --- need to setup new domain name.
googleAuthURL: 'https://googleauth.sharmans.net.au', // new may 24 TFA noode.js authentication app services. --- googleAuthTSA.backvault.com.au --- need to setup new domain name.


 // sopDocServer
  sopDocServerURL: 'https://sopnode.nickbowen.com.au', // root directory
  // Azure Web Docker WORD PROCESSOR OF FILES AND MERGE SCRIPTS
  sopDocxServerURL: 'https://sopdocserver.azurewebsites.net/api/documenteditor/Import', // root directory

  // Base file Directory Roots.
  


  // Files - Internal Access and Links
  $fileURL: 'https://tsa.backvault.com.au', // Base URL for all file locations // 'before /APP_PHP/.... etc'
  $fileFolderDocs: '/APP_PHP/assets/docs/', // the location for system documents from $file_url before (subject number) is applied



  // Docx Templates and Uploads - Internal Links And Template Locations
  baseUploadURL: 'http://tsa.backvault.com.au/APP_PHP/WordTemplates', // all templates reside in the same directory.
  baseUploadURL_SSL: 'https://tsa.backvault.com.au/APP_PHP/WordTemplates', // all templates reside in the same directory.
  baseUploadURLOriginalWordTemplates: 'http://tsa.backvault.com.au/APP_PHP/OriginalWordTemplates',
  baseUploadURLEmailTemplates: 'http://tsa.backvault.com.au/APP_PHP/emailTemplates', // all templates reside in the same directory.

  baseUploadURLDocxThemeTemplates: 'http://tsa.backvault.com.au/APP_PHP/themeTemplates',
  baseUploadURLEmailTemplatesNOHTTP: 'tsa.backvault.com.au/APP_PHP/themeTemplates',
  baseUploadURLEmailTemplatesSSL: 'https://tsa.backvault.com.au/APP_PHP/themeTemplates',

// Links to external Assets
  baseUploadURL_UserAssets: 'https://tsa.backvault.com.au/APP_PHP/uploads/assets/users', // no trailing slash // added brand_id to HTML
  // tslint:disable-next-line:max-line-length
  baseUploadURL_BrandAssets: 'https://tsa.backvault.com.au/APP_PHP/uploads/assets/brands',

  baseUploadURL_JobAssets: 'https://tsa.backvault.com.au/APP_PHP/uploads/assets/jobs',
  file_folder_jobAssets: '/home/backvaul/tsa.backvault.com.au/APP_PHP/uploads/assets/jobs',
  
  file_server_location_JobAssets: '/APP_PHP/uploads/assets/jobs',
// ... !!!! NOTICE !!!!  PHP has a settings file that also needs to be set as per upload:
// .... app_environment_settings.php - located in the php directory of the application.
// tslint:disable-next-line:max-line-length
// :: Follow same naming principals (Hand update PHP per APP Setup. - As APP_PHP directory and functions will always run on the same server the root application is insalled)

// myob_TaxCode: '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe', // Sharmans Company File
// myob_FreightTaxCode: '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe', // Sharmans Company File.


// ALL SET TO TSA BACKVAULT AND TEST NIJO DREAM myob File
// things to think about -- myob to be more transporatble between companies.
myobCustomeID: '8fdc7540-80b2-4331-837f-93bec7a8cb48', // company file ID returned from first access to admin API
myob_api_key: '4fb7b278-b0ae-4ef6-ba54-84b8d9969245',
myob_api_secret: 'BTI86OsF6grafGLw1E7I8HdR',
redirect_URL: 'http://localhost:1050',
myob_TaxCode: '97dfe2e0-e6a5-41e8-ae57-04b4cdeccbb6', // Nix NIjo Dream Company FIle / Testignn
myob_FreightTaxCode: '97dfe2e0-e6a5-41e8-ae57-04b4cdeccbb6', // NIx Nijo Dream Comanpy file for testing
myob_DefaultPaymentsAccount: '8089f325-d0f9-4f44-9874-6e90158ca4dc', // Set to prevent sycing errors when payments are made into wrong accounts. _ usually checking.
company_customer_id_for_check: '8bc36444-d701-4c20-ad86-560b9c0a65af', // A CUSTOMER ID THAT MUST EXIST IN MYOB FOR TSA TO WORK. "CompanyName":"BaseMyobCheckerCompany"
myob_developer_email: 'emailme@nickbowen.com.au', // developer API who setup and maintains connections.




// brand_wordpress_URL: 'https://localhost/dev.temperosystems.com.au',
// brand_api_key: 'ck_ce1b81259bfb4307aee5fd726bb32be9e1c779aa',
// brand_api_secret: 'cs_6a5e5d1cdd2b4b0f1c41ef2dc718778e776b9420',

// WebHookAPI_Website: 'https://localhost/dev.temperosystems.com.au',
// WebHookAPI_WebsiteSSL: 'https://localhost/dev.temperosystems.com.au',
// WebHookAPI: '/wp-json/pps_distrohub/v1/pps', // base URL of the custom API connecivity - custom pligin api.
// WebHook_username: 'nick',
// WebHook_password: 'Yi$5uIV1l3',
// WebHookAPI_PHP_Assets: 'https://ppsdistrohub.nickbowen.com.au/APP_PHP/assets/wp_api' ,


// Test with live Settings as it seems to not pick up the production evironment file.? USE THIS
brand_wordpress_URL: 'https://dev.temperosystems.com.au',
// brand_api_key: 'ck_9b509b9848a9f9c39fe5f96803fa3e165be1fa0e',
// brand_api_secret: 'cs_504bd1d2814faaeb0b67dae7b826c5dcc5318f2f',
brand_api_key: 'ck_ce1b81259bfb4307aee5fd726bb32be9e1c779aa',
brand_api_secret: 'cs_6a5e5d1cdd2b4b0f1c41ef2dc718778e776b9420',

WebHookAPI_Website: 'https://dev.temperosystems.com.au',
WebHookAPI_WebsiteSSL: 'https://dev.temperosystems.com.au',
WebHookAPI: '/wp-json/pps_distrohub/v1/pps', // base URL of the custom API connecivity
WebHook_username: 'nick',
WebHook_password: 'Yi$5uIV1l3',
WebHookAPI_PHP_Assets: 'https://ppsdistrohub.nickbowen.com.au/APP_PHP/assets/wp_api' ,


// LIVE WEBSITE FOR LIVE DATA
// brand_wordpress_URL: 'https://temperosystems.com.au',
// // brand_api_key: 'ck_9b509b9848a9f9c39fe5f96803fa3e165be1fa0e',
// // brand_api_secret: 'cs_504bd1d2814faaeb0b67dae7b826c5dcc5318f2f',
// brand_api_key: 'ck_ce1b81259bfb4307aee5fd726bb32be9e1c779aa',
// brand_api_secret: 'cs_6a5e5d1cdd2b4b0f1c41ef2dc718778e776b9420',

// WebHookAPI_Website: 'https://temperosystems.com.au',
// WebHookAPI_WebsiteSSL: 'https://temperosystems.com.au',
// WebHookAPI: '/wp-json/pps_distrohub/v1/pps', // base URL of the custom API connecivity
// WebHook_username: 'nick',
// WebHook_password: 'Yi$5uIV1l3',
// WebHookAPI_PHP_Assets: 'https://ppsdistrohub.nickbowen.com.au/APP_PHP/assets/wp_api' ,


/// Dev.tempersystems.com.au as the assets.
// brand_wordpress_URL: 'https://dev.temperosystems.com.au',
// // brand_api_key: 'ck_9b509b9848a9f9c39fe5f96803fa3e165be1fa0e',
// // brand_api_secret: 'cs_504bd1d2814faaeb0b67dae7b826c5dcc5318f2f',
// brand_api_key: 'ck_ce1b81259bfb4307aee5fd726bb32be9e1c779aa',
// brand_api_secret: 'cs_6a5e5d1cdd2b4b0f1c41ef2dc718778e776b9420',

// WebHookAPI_Website: 'https://dev.temperosystems.com.au',
// WebHookAPI_WebsiteSSL: 'https://dev.temperosystems.com.au',
// WebHookAPI: '/wp-json/pps_distrohub/v1/pps', // base URL of the custom API connecivity
// WebHook_username: 'nick',
// WebHook_password: 'Yi$5uIV1l3',
// WebHookAPI_PHP_Assets: 'https://dev.ppsdistrohub.nickbowen.com.au/APP_PHP/assets/wp_api' ,




};
